import React from 'react';
import { Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import { partial } from '../../../util/translation/translation';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';
import ApiKeyValue from '../../../shared/components/custom/ApiKeyValue';

const ContentAPIList = ({ apiAccess, handleModal }) => {
  const s = partial('shared');

  const renderKeys = () => {
    return apiAccess.map((access) => (
      <tr key={`apiAccess-${access.id}`}>
        <td className="table-stack__primary">
          <strong className="font-weight-500">{access.entityName}</strong>
        </td>
        <td data-label={s('key')}>
          <ApiKeyValue apiKey={access.apiKey} id={`news-${access.id}`} />
        </td>
        <td data-label={s('usage')}>
          {(access.usage?.requestAmount ?? 0).toLocaleString()}
        </td>
        <td className="table-stack__actions">
          <div className="icon-actions justify-content-end">
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              title={s('delete')}
              tone="danger"
              id={`delete-key-${access.id}`}
              onClick={() => handleModal(true, access.id, 'api_access')}
            />
          </div>
        </td>
      </tr>
    ));
  };

  return (
    <FormCard
      title={
        <>
          API
          <span className="form-card__count">{apiAccess.length}</span>
        </>
      }
      actions={
        <Link to="/news_api/create">
          <Button size="sm" color="primary" className="mb-0">
            {s('create')} {s('key').toLowerCase()}
          </Button>
        </Link>
      }
      bodyClassName="form-card__body--flush"
      className="mb-3"
    >
      <Table responsive striped className="table--roomy table--stack mb-0">
        <thead>
          <tr>
            <th>{s('companyName')}</th>
            <th>{s('key')}</th>
            <th>{s('usage')}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {renderKeys()}
          {!apiAccess.length && (
            <tr>
              <td colSpan={4} className="settings-empty">
                {s('noApiKeys')}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </FormCard>
  );
};

export default ContentAPIList;
